













































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UnitProjectData, getList } from '@/api/heritageUnit/unitProject'
//import ViewLink from '@/components/viewLink.vue'

@Component({
  components: {}
})
export default class UnitProjectsView extends Vue {
  public name = 'UnitProjectsView'
  public expandNames: string[] = ['projects']
  public loading = false
  public list: UnitProjectData[] = []
  public $refs!: {
  }
  //数据加载
  public loadData(unitId:number) {
    if (unitId == 0) {
      this.$message({
        message: '文保单位未匹配，请检查',
        type: 'warning'
      })
      console.log('UnitId为0，请赋值')
    }
    else {
      //触发控件的查询事件
      this.fetchData(unitId)
    }
  }
  public fetchData(unitId: number) {
    this.loading = true
    getList(unitId).then((response: { data: any }) => {
      this.list = response.data
      this.loading = false
    }).catch((error: any) => {
      console.log(error)
    })
  }
}
